export default __webpack_public_path__ + "f75a6c309b479f2e6dcb8056d918d2d5.png";